import React from 'react';

const Message = (props) => {
  const { message, success, showFullscreen } = props;
  const classNameSuccess = (success) ? 'success' : '';
  const classNameFullscreen = (showFullscreen) ? 'container-fullscreen' : '';

  return (
    <div className={`messageComponent ${classNameSuccess} ${classNameFullscreen}`}>
      <div>
        <h4>{message}</h4>
      </div>
    </div>
  )
};

export default Message;



// WEBPACK FOOTER //
// ./source/client/components/common/message.jsx